<template>
  <UiCheckbox
    :value="categoryStore.tmpFilters[EExperienceFilterType.CHILDREN_ALLOWED].children_allowed"
    :label="t('label')"
    :checked="categoryStore.tmpFilters[EExperienceFilterType.CHILDREN_ALLOWED].children_allowed"
    @inputValue="categoryStore.setChildrenAllowed"
  />
</template>

<script setup lang="ts">
  import { UiCheckbox } from '@experience/core-checkbox-ui';
  import { useI18n } from '@experience/i18n';
  import ru from '../i18n/ru.json';
  import { EExperienceFilterType } from '@/widgets/filtersBlock';
  import { useCategoryStore } from '@/shared/store';

  const categoryStore = useCategoryStore();

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });
</script>
